export const maskCpf = (cpf: any) => {
  cpf = cpf?.replace(/\D/g, '')

  if (cpf?.length <= 11) {
    cpf = cpf?.replace(/(\d{3})(\d)/, '$1.$2')
    cpf = cpf?.replace(/(\d{3})(\d)/, '$1.$2')
    cpf = cpf?.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  }

  return cpf
}

export const maskCrp = (crp: any) => {
  crp = crp?.replace(/\D/g, '')

  if (crp?.length <= 9) {
    crp = crp?.replace(/^(\d{2})(\d)/, '$1/$2')
  }

  return crp
}

export const maskCep = (cep: any) => {
  cep = cep?.replace(/\D/g, '')

  if (cep?.length <= 8) {
    cep = cep?.replace(/^(\d{5})(\d)/, '$1-$2')
  }

  return cep
}

export const maskTel = (tel: any) => {
  tel = tel?.replace(/\D/g, '')

  if (tel?.length <= 11) {
    tel = tel?.replace(/^(\d\d)(\d)/g, '($1) $2')
    tel = tel?.replace(/(\d{5})(\d)/, '$1-$2')
  }

  return tel
}

export const maskTelResidential = (tel: any) => {
  tel = tel?.replace(/\D/g, '')

  if (tel?.length <= 10) {
    tel = tel?.replace(/^(\d\d)(\d)/g, '($1) $2')
    tel = tel?.replace(/(\d{4})(\d)/, '$1-$2')
  }

  return tel
}
